import React from "react";
import { linkify, linkifyHighlight } from "../utils";

/** The one way task/note text is displayed: URLs (https · http · www · bare domains) become
 *  anchors that open in a new tab and swallow every gesture event, so a link tap never toggles,
 *  swipes, opens the editor or counts as a Screensaver tap. Optional `term` highlights a search. */
export const SafeLinkText = ({ text, term, as: Tag = "span", className, ...rest }) => {
    if (text == null || text === "") return null;
    return (
        <Tag className={className} {...rest}>
            {term ? linkifyHighlight(text, term) : linkify(text)}
        </Tag>
    );
};

export default SafeLinkText;
